var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgItaly = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "18-Italy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4819 6.99997C12.4819 8.5978 11.8597 10.1 10.7298 11.2298C9.59999 12.3597 8.0978 12.9819 6.49997 12.9819C4.90214 12.9819 3.39995 12.3597 2.27012 11.2298C1.14029 10.1 0.518066 8.5978 0.518066 6.99997C0.518066 5.40214 1.14029 3.89995 2.27012 2.77012C3.39995 1.64029 4.90214 1.01807 6.49997 1.01807C8.0978 1.01807 9.59999 1.64029 10.7298 2.77012C11.8597 3.89995 12.4819 5.40214 12.4819 6.99997Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4819 7.00018C12.4819 8.59801 11.8596 10.1001 10.7297 11.23C10.116 11.8437 9.39241 12.3078 8.60327 12.6034V1.39697C9.39241 1.69252 10.116 2.15666 10.7297 2.77035C11.8596 3.90023 12.4819 5.40234 12.4819 7.00018Z",
    fill: "#CE2B37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.39674 1.39697V12.6034C3.6076 12.3078 2.88397 11.8437 2.27027 11.23C1.14039 10.1001 0.518066 8.59801 0.518066 7.00018C0.518066 5.40234 1.14039 3.90023 2.27027 2.77035C2.88397 2.15666 3.6076 1.69252 4.39674 1.39697Z",
    fill: "#009246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.13,
    d: "M12.4821 7.00004C12.4821 8.59787 11.8598 10.1 10.7299 11.2299C9.60006 12.3597 8.09795 12.9821 6.50012 12.9821C5.28086 12.9821 4.11746 12.6197 3.13281 11.9461C4.14336 12.3862 5.25801 12.5415 6.37748 12.3867C7.98318 12.1645 9.40607 11.3302 10.3844 10.0378C11.3624 8.74514 11.7788 7.14908 11.5567 5.54363C11.3622 4.14029 10.7007 2.8766 9.6742 1.92725C10.0523 2.16465 10.4065 2.44674 10.7299 2.77021C11.8598 3.9001 12.4821 5.40221 12.4821 7.00004Z",
    fill: "#160204"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.25,
    d: "M9.34359 1.73408C8.27846 1.42686 7.14604 1.41213 6.04637 1.70285C4.44346 2.12687 3.10182 3.14961 2.26799 4.58266C1.43441 6.01596 1.20869 7.68793 1.63271 9.29084C1.89145 10.2694 2.37336 11.1504 3.0358 11.8784C2.76564 11.6859 2.50971 11.4694 2.27027 11.2299C1.14039 10.1 0.518066 8.59793 0.518066 7.0001C0.518066 5.40227 1.14039 3.90016 2.27027 2.77027C3.40016 1.64039 4.90227 1.01807 6.5001 1.01807C7.50938 1.01807 8.48031 1.26639 9.34359 1.73408Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgItaly);
export default ForwardRef;